<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 32 32">
    <path fill="#000" fill-rule="evenodd" d="M28 24V13.427c0-.891-.446-1.724-1.188-2.219L17.48 4.986c-.895-.597-2.063-.597-2.958 0l-9.334 6.222C4.446 11.703 4 12.536 4 13.428V24c0 1.473 1.194 2.667 2.667 2.667h18.666C26.806 26.667 28 25.473 28 24zm-13.333-6.667c-.737 0-1.334.836-1.334 1.867v7.467h5.334V19.2c0-1.03-.597-1.867-1.334-1.867h-2.666z" clip-rule="evenodd"/>
  </svg>
</template>
